//This file is generated from c# do not modify, any changes will be overridden when re-generated.
import { ModelBase } from "../../pillar/common/models/ModelBase";

export class ExtractListModel extends ModelBase {
  static readonly $typeName = 'ExtractListModel';
  public key: string;
  public createdDate: Date;
  public createdBy: string;
  public finalizedDate: Date;
  public finalizedBy: string;
  public fileType: string;
  public fileName: string;
  public status: string;
  public claimCount: string;
  public totalChargeAmount: string;
  public url: string;

}



// WEBPACK FOOTER //
// ./src/app/extracts/models/ExtractListModel.ts